import registerEndpoints from "./endpoints/register.js";
import infoEndpoints from "./endpoints/info.js";
import serverConfigEndpoints from "./endpoints/serverConfig.js";
import publicGamesEndpoints from "./endpoints/games.js";
import publicAccVariables from "./endpoints/account-variables.js";
import publicReferralEndpoints from "./endpoints/referral.js";
const publicTags = ["register", "info", "serverConfig", "games", "game-providers", "game-categories", "account-variables", "referral"];
const publicAPIConfig = {
  reducerPath: "publicApi",
  tagTypes: publicTags,
  endpoints: (builder) => ({
    ...registerEndpoints(builder),
    ...infoEndpoints(builder),
    ...serverConfigEndpoints(builder),
    ...publicGamesEndpoints(builder),
    ...publicAccVariables(builder),
    ...publicReferralEndpoints(builder)
  })
};
export {
  infoEndpoints,
  publicAPIConfig,
  publicAccVariables,
  publicGamesEndpoints,
  publicReferralEndpoints,
  publicTags,
  registerEndpoints,
  serverConfigEndpoints
};
